import wretchAdapter from '@/shared/api/adapters/wretch';

export default wretchAdapter(CONFIG.PLATFORM_SERVICE);
